import { render, staticRenderFns } from "./b-states.vue?vue&type=template&id=3e30d2d9&scoped=true"
import script from "./b-states.vue?vue&type=script&lang=ts"
export * from "./b-states.vue?vue&type=script&lang=ts"
import style0 from "./b-states.vue?vue&type=style&index=0&id=3e30d2d9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e30d2d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e30d2d9')) {
      api.createRecord('3e30d2d9', component.options)
    } else {
      api.reload('3e30d2d9', component.options)
    }
    module.hot.accept("./b-states.vue?vue&type=template&id=3e30d2d9&scoped=true", function () {
      api.rerender('3e30d2d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/biz/b-states.vue"
export default component.exports